// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function PhoneIncomingBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="m28 19.35-5.886-2.638-.023-.01a2.486 2.486 0 0 0-2.375.218 1.627 1.627 0 0 0-.14.105L16.788 19.4c-1.626-.881-3.304-2.546-4.187-4.151l2.383-2.833c.038-.046.073-.094.106-.143a2.5 2.5 0 0 0 .197-2.377L12.65 4a2.508 2.508 0 0 0-2.598-1.481A7.534 7.534 0 0 0 3.5 10c0 10.201 8.299 18.5 18.5 18.5a7.534 7.534 0 0 0 7.481-6.552A2.508 2.508 0 0 0 28 19.35Zm-6 6.15A15.52 15.52 0 0 1 6.5 10a4.536 4.536 0 0 1 3.56-4.442l2.352 5.25-2.395 2.852a1.504 1.504 0 0 0-.107.145 2.5 2.5 0 0 0-.16 2.455c1.178 2.41 3.604 4.82 6.039 6a2.5 2.5 0 0 0 2.461-.181c.048-.033.095-.068.139-.107l2.803-2.383 5.25 2.351A4.537 4.537 0 0 1 22 25.5ZM18.5 12V7a1.5 1.5 0 1 1 3 0v1.375l3.44-3.44a1.503 1.503 0 0 1 2.125 2.125l-3.44 3.44H25a1.5 1.5 0 1 1 0 3h-5a1.5 1.5 0 0 1-1.5-1.5Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
